import { OrgRoleForCreationDto } from '@/features/users/types';
import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { UserKeys } from '../user.keys';
import { OrgRoleKeys } from './orgrole.keys';

export const addOrgRole = (orgRoleForCreationDto: OrgRoleForCreationDto) =>
  clients.admin.post(`/orgroles`, orgRoleForCreationDto).then(() => {});

export function useAddOrgRole(
  options?: UseMutationOptions<void, AxiosError, OrgRoleForCreationDto>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    (orgRoleForCreationDto: OrgRoleForCreationDto) => addOrgRole(orgRoleForCreationDto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(UserKeys.all);
        queryClient.invalidateQueries(OrgRoleKeys.all);
      },
      onError: (error) => {
        console.error(error);
      },
      ...options,
    },
  );
}
